import React, { useEffect } from "react";
import {
    Box,
    Button,
    Card,
    Avatar,
    DialogActions,
    ListItemSecondaryAction,
    ListItemAvatar,
    ListItemText,
    Divider,
    Checkbox,
    ListItem,
    Chip,
    Collapse,
    Container,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    List,
    TextField,
} from "@material-ui/core";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ToggleButton from "../../components/ToggleButton/ToggleButton";
import {
    getBankAccountRequest,
    updateBankAccountRequest,
} from "../../store/shopping/shopping.actions";
import { getBankAccounts } from "../../store/shopping/shopping.selector";
import ManageBank from "./ManageBank";
import Swal from "sweetalert2";
import { Alert } from "@material-ui/lab";
import { useNavigate } from "react-router-dom";
import _ from "underscore";
import ShoppingAPI from "../../store/shopping/shopping.api";

const WithdrawBalance = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isOpen, setOpen] = useState(false);
    const [transactions, setTransactions] = useState(false);
    const [showCard, setShowCard] = useState(false);
    const [selected, setSelected] = useState([]);
    const [selectedItem, setSelectedItem] = useState({});
    const { bankAccounts } = useSelector((state) => {
        return {
            bankAccounts: getBankAccounts(state),
        };
    });

    useEffect(() => {
        setSelectedItem({});
        setShowCard(false);
    }, [bankAccounts]);

    useEffect(() => {
        dispatch(getBankAccountRequest());
        ShoppingAPI.GetUserTransactions("")
            .then((x) => {
                setTransactions(x.data);
            })
            .catch((x) => {
                setTransactions([]);
            });
    }, []);

    return (
        <div>
            <div className="text-sm my-3.5">
                <h5 className="font-bold text-ebony-color mb-1">
                    Withdraw Balance
                </h5>
                <p className="text-black-60 font-medium">
                    Your request will be processed within 5 working days. No
                    withdrawal fees.
                </p>
            </div>
            {/* <Alert severity="info" className="my-3.5">
                The minimum withdrawal amount is RM 50
            </Alert> */}

            {/* <div className="grid grid-cols-1 xs:grid-cols-3 gap-2 text-purple-color text-sm uppercase mb-4">
                <div className="bg-[#FBF7FF] py-3 border border-[#F1E4FF] text-center rounded-lg">
                    <span>MYR 100</span>
                </div>
                <div className="bg-[#FBF7FF] py-3 border border-[#F1E4FF] text-center rounded-lg">
                    <span>MYR 200</span>
                </div>
                <div className="bg-[#FBF7FF] py-3 border border-[#F1E4FF] text-center rounded-lg">
                    <span>MYR 500</span>
                </div>
            </div> */}

            <div className="flex gap-3 mb-3.5">
                <button
                    onClick={() => setOpen(true)}
                    className="py-2.5 px-5 rounded-lg text-sm font-bold text-white bg-orange-color capitalize border border-orange-color"
                >
                    Withdraw
                </button>
                <button
                    onClick={() => navigate("/page/account/withdrawal")}
                    className="py-2.5 px-5 rounded-lg text-sm font-medium text-black-50 bg-white capitalize border border-black-10"
                >
                    Cancel
                </button>
            </div>
            <Divider />
            <div className="text-sm my-3.5">
                <h5 className="font-bold text-ebony-color mb-1">
                    Bank Details
                </h5>
                <p className="text-black-60 font-medium">
                    The payments from subscriptions and completed orders will be
                    deposited into this account
                </p>
            </div>

            <div className="">
                <div className="flex flex-col sm:flex-row gap-4 mb-8">
                    {/* Bank Card */}
                    {bankAccounts.map((x) => {
                        return (
                            <div className="flex-1 p-4 border border-black-10 rounded-10">
                                <div className="flex justify-between mb-2">
                                    <div className="">
                                        <span className="text-ebony-color text-sm font-bold mb-0.5">
                                            {x.bankName}
                                        </span>
                                        <div className="text-sm text-black-60 font-medium w-[94px]">
                                            <span className="block">
                                                {x.accountName}
                                            </span>
                                            <span className="block">
                                                {x.accountNumber}
                                            </span>
                                        </div>
                                    </div>
                                    <ToggleButton
                                        enabled={x.isDefault}
                                        onChange={() => {
                                            dispatch(
                                                updateBankAccountRequest({
                                                    accountName: x.accountName,
                                                    accountNumber:
                                                        x.accountNumber,
                                                    bankName: x.bankName,
                                                    status: x.status,
                                                    isDefault: x.isDefault
                                                        ? false
                                                        : true,
                                                    _id: x._id,
                                                })
                                            );
                                        }}
                                    />
                                </div>

                                <div className=" flex items-center gap-2">
                                    <button
                                        onClick={() => {
                                            setShowCard(true);
                                            setSelectedItem(x);
                                        }}
                                        className="py-[7px] w-full xs:w-[92px] px-5 bg-orange-color rounded-lg text-sm border border-orange-color font-bold text-white flex items-center justify-center capitalize"
                                    >
                                        <span className="mr-2.5">
                                            <svg
                                                width="15"
                                                height="15"
                                                viewBox="0 0 15 15"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M6.75 2.34473H3C2.17157 2.34473 1.5 3.0163 1.5 3.84473V12.0947C1.5 12.9232 2.17157 13.5947 3 13.5947H11.25C12.0784 13.5947 12.75 12.9232 12.75 12.0947V8.34473M11.6893 1.28407C12.2751 0.69828 13.2249 0.69828 13.8107 1.28407C14.3964 1.86985 14.3964 2.8196 13.8107 3.40539L7.37132 9.84473H5.25L5.25 7.72341L11.6893 1.28407Z"
                                                    stroke="white"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </span>
                                        <span>Edit</span>
                                    </button>

                                    <button
                                        onClick={() => {
                                            Swal.fire({
                                                title: "Confirm delete?",
                                                text: "A deleted bank cannot be restored later.",
                                                icon: "warning",
                                                showCancelButton: true,
                                                confirmButtonColor: "red",
                                                cancelButtonText: "Cancel",
                                                confirmButtonText: "Delete",
                                                customClass: {
                                                    cancelButton:
                                                        "order-1 right-gap",
                                                    confirmButton: "order-2",
                                                    denyButton: "order-3",
                                                },
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    let it = x;
                                                    x.status = "Inactive";
                                                    dispatch(
                                                        updateBankAccountRequest(
                                                            it
                                                        )
                                                    );
                                                }
                                            });
                                        }}
                                        className="py-[7px] w-full xs:w-[92px] px-5 bg-white rounded-lg text-sm border border-black-10 font-medium text-black-50 flex items-center justify-center capitalize"
                                    >
                                        <span className="mr-2.5">
                                            <svg
                                                width="15"
                                                height="16"
                                                viewBox="0 0 15 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M12.75 3.84473L12.0995 12.9516C12.0434 13.7366 11.3903 14.3447 10.6033 14.3447H4.39668C3.60972 14.3447 2.95656 13.7366 2.90049 12.9516L2.25 3.84473M6 6.84473V11.3447M9 6.84473V11.3447M9.75 3.84473V1.59473C9.75 1.18051 9.41421 0.844727 9 0.844727H6C5.58579 0.844727 5.25 1.18051 5.25 1.59473V3.84473M1.5 3.84473H13.5"
                                                    stroke="black"
                                                    strokeOpacity="0.5"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </span>
                                        <span>delete</span>
                                    </button>
                                </div>
                            </div>
                        );
                    })}

                    {/* Add Bank card  */}
                    <div className="flex-1 flex justify-center items-center border border-black-10 p-3 rounded-10">
                        <div className="text-center">
                            <p className="text-sm font-medium text-black-60 mb-2.5">
                                Add New Bank
                            </p>
                            <button
                                onClick={() => setShowCard(true)}
                                className="py-[7px] px-11 bg-orange-color rounded-lg text-sm border border-orange-color font-bold text-white flex items-center justify-center capitalize"
                            >
                                <span className="mr-2.5">
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M8 5.40527V7.65527M8 7.65527V9.90527M8 7.65527H10.25M8 7.65527H5.75M14.75 7.65527C14.75 11.3832 11.7279 14.4053 8 14.4053C4.27208 14.4053 1.25 11.3832 1.25 7.65527C1.25 3.92735 4.27208 0.905273 8 0.905273C11.7279 0.905273 14.75 3.92735 14.75 7.65527Z"
                                            stroke="white"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </span>
                                <span>add</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog
                maxWidth="sm"
                fullWidth
                open={showCard}
                onClose={() => setShowCard(false)}
            >
                <DialogContent>
                    <ManageBank
                        mode={selectedItem._id ? "edit" : "add"}
                        item={selectedItem}
                        onClose={() => setShowCard(false)}
                    />
                </DialogContent>
            </Dialog>
            <Dialog open={isOpen} maxWidth="sm" onClose={() => setOpen(false)}>
                <DialogTitle className="text-center">
                    <h4>Withdraw Funds</h4>
                    <p className="text-small">
                        Your request will be processed within 5 working days.
                        <br />
                        No withdrawal fees.
                    </p>
                </DialogTitle>
                <DialogContent>
                    <Alert severity="info">
                        The minimum withdrawal amount is RM50
                    </Alert>
                    <List disablePadding>
                        {transactions &&
                            _.sortBy(transactions, "payoutStatus").map((x) => {
                                return (
                                    <ListItem disableGutters>
                                        <ListItemText
                                            primary={x.type}
                                            primaryTypographyProps={{
                                                className: "capitalize",
                                            }}
                                            secondary={
                                                x.currency + " " + x.netAmount
                                            }
                                        />
                                        <ListItemSecondaryAction>
                                            <Checkbox
                                                color={
                                                    x.payoutStatus ===
                                                    "Initiated"
                                                        ? "primary"
                                                        : "default"
                                                }
                                                disabled={
                                                    x.payoutStatus !==
                                                    "Initiated"
                                                }
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setSelected([
                                                            ...selected,
                                                            x,
                                                        ]);
                                                    } else {
                                                        setSelected(
                                                            selected.filter(
                                                                (z) =>
                                                                    z._id !==
                                                                    x._id
                                                            )
                                                        );
                                                    }
                                                }}
                                                checked={
                                                    x.payoutStatus !==
                                                        "Initiated" ||
                                                    selected.filter(
                                                        (z) => z._id === x._id
                                                    ).length > 0
                                                }
                                            />
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                );
                            })}
                    </List>
                    {/* <MUIDataTable
            title={"Payout List"}
            data={data}
            columns={columns}
            options={{
              selectableRows: false,
              search: false,
              download: false,
              print: false,
              viewColumns: false
            }}
          /> */}
                </DialogContent>
                <DialogActions>
                    <Button
                        className="mt-4"
                        disabled={
                            selected.length === 0 &&
                            selected.reduce(
                                (partialSum, a) => partialSum + a,
                                0
                            ) < 50
                        }
                        variant="contained"
                        onClick={() => {
                            setOpen(false);
                            if (selected.length > 0) {
                                Swal.fire({
                                    title: "Withdraw Request",
                                    text: "Confirm withdrawal of the selected funds ?",
                                    icon: "question",
                                    showCancelButton: true,
                                    cancelButtonColor: "green",
                                    showConfirmButton: true,
                                    cancelButtonText: "Cancel",
                                    confirmButtonText: "Confirm",
                                    customClass: {
                                        cancelButton: "order-1 right-gap",
                                        confirmButton: "order-2",
                                        denyButton: "order-3",
                                    },
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        setOpen(false);
                                        ShoppingAPI.RequestWithdrawal({
                                            ids: selected.map((x) => x._id),
                                        }).then((res) => {
                                            Swal.fire({
                                                title: "Withdraw Request",
                                                text: "Request sent successfully. Admin will approve it soon",
                                                icon: "success",
                                                showCancelButton: true,
                                                cancelButtonText: "Close",
                                                showConfirmButton: false,
                                                customClass: {
                                                    cancelButton:
                                                        "order-1 right-gap",
                                                    confirmButton: "order-2",
                                                    denyButton: "order-3",
                                                },
                                            }).then((result) => {
                                                window.location.reload();
                                            });
                                        });
                                    }
                                });
                            }
                        }}
                        color="primary"
                        fullWidth
                    >
                        Withdraw
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default WithdrawBalance;
